import { Navigate } from "react-router-dom";
import { useRole } from "@/store/role";
import { hasValidAccessToken, loginRedirectPath } from "@/lib/auth";
import { firstAllowedPath, isStudentUser } from "@/config/navigation";

/**
 * Student-only routes — OTP session + role requester.
 * Staff users are redirected to their first allowed page.
 */
export function StudentRoute({ children }) {
  const { currentUser, permissions } = useRole();

  if (!hasValidAccessToken()) {
    return <Navigate to={loginRedirectPath()} replace />;
  }

  if (!isStudentUser(currentUser)) {
    const redirectTo = firstAllowedPath(currentUser, permissions);
    if (redirectTo) return <Navigate to={redirectTo} replace />;
    return <Navigate to="/login" replace />;
  }

  return children;
}
